export default [
    {
        path: "supplier",
        name: "Supplier",meta:{
            permissionPath: 'customers.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "stores" */ "@/views/loyaltyPanel/supplierManagement/tabs/Supplier.vue"
            )
    },

    {
        path: "message",
        name: "Message",
        meta:{
            permissionPath: 'customers.notification_message.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "registrationPlans" */ "@/views/loyaltyPanel/supplierManagement/tabs/Message.vue"
            )
    }
];
